export default __webpack_public_path__ + "static/media/master-card.a1c6e906.png";